import { ApplicationRef, ComponentRef, EnvironmentInjector, Injectable, Injector, Type, createComponent, inject } from '@angular/core';
import {ModalComponent} from './modal.component';
import {ModalConfig} from './modal-config';
import {ModalInjector} from './modal-injector';
import {ModalRef} from './modal-ref';

@Injectable()
export class ModalService
 {
    private environmentInjector = inject(EnvironmentInjector);
    private appRef = inject(ApplicationRef);
    private injector = inject(Injector);

    modalComponentRef: ComponentRef<ModalComponent>;

    public open(componentType: Type<any>, config: ModalConfig) {
        const modalRef = this.appendModalComponentToBody(config);
        this.modalComponentRef.instance.childComponentType = componentType;
        return modalRef;
    }

    private appendModalComponentToBody(config: ModalConfig) {
        const map = new WeakMap();
        map.set(ModalConfig, config);

        const modalRef = new ModalRef();
        map.set(ModalRef, modalRef);

        const sub = modalRef.afterClosed.subscribe(()=> {
            this.removeModalComponentFromBody();
            sub.unsubscribe();
        });

        const componentRef = createComponent(ModalComponent, {
            environmentInjector: this.environmentInjector,
            elementInjector: new ModalInjector(this.injector, map)
        });

        this.appRef.attachView(componentRef.hostView);
        document.body.appendChild(componentRef.location.nativeElement);

        this.modalComponentRef = componentRef;

        this.modalComponentRef.instance.onClose.subscribe(() => {
            this.removeModalComponentFromBody();
        });
        return modalRef;

    }
    private removeModalComponentFromBody() {
        this.appRef.detachView(this.modalComponentRef.hostView);
        this.modalComponentRef.destroy();
    }
}
